<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :isDashboardView="false"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="saveActivity" method="POST">
                <h2>WHAT ARE YOU DOING?</h2>
                <select class="col-md-3" name="priceAction" v-model="selectedActivity" required>
                    <option></option>
                    <option v-for="(action,id) in actions" :value="id">{{ action }}</option>
                </select>
                <br />
                <br />
                <button class="btn-round-red" type="submit">NEXT STEP ></button>
            </form>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            actions:[],
            selectedActivity:""
        }
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        saveActivity() {
            axios.post(`/api/saveActivity`, {userId: this.user.id, selectedActivity: this.selectedActivity} ).then((response) => {
                let submissionId = response.data;
                this.$router.push({
                    name: "PriceWorkflowCompanySelect",
                    params: { ppId: submissionId }
                });
            });
        }
    },
    created() {
        axios.get(`/api/getAllActions/`).then(response => {
            this.actions = response.data;
        });
    }
};
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }
</style>